import { render, staticRenderFns } from "./mingxi.vue?vue&type=template&id=c9235d9e&scoped=true"
import script from "./mingxi.vue?vue&type=script&lang=js"
export * from "./mingxi.vue?vue&type=script&lang=js"
import style0 from "./mingxi.vue?vue&type=style&index=0&id=c9235d9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9235d9e",
  null
  
)

export default component.exports